module.exports = __webpack_public_path__ + "img/kg.5908392a.svg";